import { useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import Swiper from "react-id-swiper";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faCar,
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import './grandi10.css';
/****Fotos Banner ****/
import Slider1 from "../../images/modelos/grandi10hb/banner/banner1.webp";
import Slider2 from "../../images/modelos/grandi10hb/banner/banner2.webp";
import Slider3 from "../../images/modelos/grandi10hb/banner/banner3.webp";
import Slider4 from "../../images/modelos/grandi10hb/banner/banner4.webp";
import Slider5 from "../../images/modelos/grandi10hb/banner/banner5.webp";
/****Fotos calidad de tiempo ****/
import Calidad from "../../images/modelos/grandi10hb/calidad/calidad.webp";
import Calidad1 from "../../images/modelos/grandi10hb/calidad/calidad1.webp";
import Calidad2 from "../../images/modelos/grandi10hb/calidad/calidad2.webp";
import Galeria1 from "../../images/modelos/grandi10hb/galeria/galeria1.webp";
import Galeria2 from "../../images/modelos/grandi10hb/galeria/galeria2.webp";
import Galeria3 from "../../images/modelos/grandi10hb/galeria/galeria3.webp";
import Galeria4 from "../../images/modelos/grandi10hb/galeria/galeria4.webp";
import Galeria5 from "../../images/modelos/grandi10hb/galeria/galeria5.webp";
import Galeria6 from "../../images/modelos/grandi10hb/galeria/galeria6.webp";
/****Fotos disenio ****/
import Interior1 from "../../images/modelos/grandi10hb/disenio/video.mp4";
import Interior2 from "../../images/modelos/grandi10hb/disenio/interior2.webp";
import Interior3 from "../../images/modelos/grandi10hb/disenio/interior3.webp";
import Interior4 from "../../images/modelos/grandi10hb/disenio/interior4.webp";
import Interior5 from "../../images/modelos/grandi10hb/disenio/interior5.webp";
import Interior6 from "../../images/modelos/grandi10hb/disenio/interior6.webp";
import Interior7 from "../../images/modelos/grandi10hb/disenio/interior7.webp";
import Interior8 from "../../images/modelos/grandi10hb/disenio/interior8.webp";
/****Fotos rendimiento ****/
import Rendimiento1 from "../../images/modelos/grandi10hb/rendimiento/rendimiento1.webp";
import Rendimiento2 from "../../images/modelos/grandi10hb/rendimiento/rendimiento2.webp";
import Rendimiento3 from "../../images/modelos/grandi10hb/rendimiento/rendimiento3.webp";
/****Fotos seguridad ****/
import Seguridad1 from "../../images/modelos/grandi10hb/seguridad/seguridad1.webp";
import Seguridad2 from "../../images/modelos/grandi10hb/seguridad/seguridad2.webp";
import Seguridad3 from "../../images/modelos/grandi10hb/seguridad/seguridad3.webp";
import Seguridad4 from "../../images/modelos/grandi10hb/seguridad/seguridad4.webp";
import Seguridad5 from "../../images/modelos/grandi10hb/seguridad/seguridad5.webp";
import Seguridad6 from "../../images/modelos/grandi10hb/seguridad/seguridad6.webp";
/****Fotos conveniencia ****/
import Conveniencia1 from "../../images/modelos/grandi10hb/conveniencia/conveniencia1.webp";
import Conveniencia2 from "../../images/modelos/grandi10hb/conveniencia/conveniencia2.webp";
import Conveniencia3 from "../../images/modelos/grandi10hb/conveniencia/conveniencia3.webp";
import Conveniencia4 from "../../images/modelos/grandi10hb/conveniencia/conveniencia4.webp";
import Conveniencia5 from "../../images/modelos/grandi10hb/conveniencia/conveniencia5.webp";
import Conveniencia6 from "../../images/modelos/grandi10hb/conveniencia/conveniencia6.webp";
import Conveniencia7 from "../../images/modelos/grandi10hb/conveniencia/conveniencia7.webp";
import Conveniencia8 from "../../images/modelos/grandi10hb/conveniencia/conveniencia8.webp";
/***showroom virtual */
import ShowRoom from "../../images/showroom/grandi10.png";

function InfoGrandi10Hb() {
  const [gallerySwiper, getGallerySwiper] = useState(null);
  const [thumbnailSwiper, getThumbnailSwiper] = useState(null);
  const gallerySwiperParams = {
    getSwiper: getGallerySwiper,
    loop: true,
    loopedSlides: 5, //looped slides should be the same
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  };

  const thumbnailSwiperParams = {
    getSwiper: getThumbnailSwiper,
    slidesPerView: 5,
    loop: true,
    freeMode: true,
    loopedSlides: 5, //looped slides should be the same
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    centeredSlides: true,
  };

  useEffect(() => {
    if (
      gallerySwiper !== null &&
      gallerySwiper.controller &&
      thumbnailSwiper !== null &&
      thumbnailSwiper.controller
    ) {
      gallerySwiper.controller.control = thumbnailSwiper;
      thumbnailSwiper.controller.control = gallerySwiper;
    }
  }, [gallerySwiper, thumbnailSwiper]);

  const onChangeMenu = (menu) => {
    switch (menu) {
      case "calidad":
        document.getElementById("tab-calidad").className = "color-hover";
        document.getElementById("tab-disenio").className = "color-normal";
        document.getElementById("tab-rendimiento").className = "color-normal";
        document.getElementById("tab-seguridad").className = "color-normal";
        document.getElementById("tab-conveniencia").className = "color-normal";
        document.getElementById("calidad").className = "d-block";
        document.getElementById("disenio").className = "d-none";
        document.getElementById("rendimiento").className = "d-none";
        document.getElementById("seguridad").className = "d-none";
        document.getElementById("conveniencia").className = "d-none";
        document.getElementById("img-carrusel").src = Slider1;
        break;
      case "disenio":
        document.getElementById("tab-calidad").className = "color-normal";
        document.getElementById("tab-disenio").className = "color-hover";
        document.getElementById("tab-rendimiento").className = "color-normal";
        document.getElementById("tab-seguridad").className = "color-normal";
        document.getElementById("tab-conveniencia").className = "color-normal";
        document.getElementById("calidad").className = "d-none";
        document.getElementById("disenio").className = "d-block";
        document.getElementById("rendimiento").className = "d-none";
        document.getElementById("seguridad").className = "d-none";
        document.getElementById("conveniencia").className = "d-none";
        document.getElementById("img-carrusel").src = Slider2;
        break;
      case "rendimiento":
        document.getElementById("tab-calidad").className = "color-normal";
        document.getElementById("tab-disenio").className = "color-normal";
        document.getElementById("tab-rendimiento").className = "color-hover";
        document.getElementById("tab-seguridad").className = "color-normal";
        document.getElementById("tab-conveniencia").className = "color-normal";
        document.getElementById("calidad").className = "d-none";
        document.getElementById("disenio").className = "d-none";
        document.getElementById("rendimiento").className = "d-block";
        document.getElementById("seguridad").className = "d-none";
        document.getElementById("conveniencia").className = "d-none";
        document.getElementById("img-carrusel").src = Slider3;
        break;
      case "seguridad":
        document.getElementById("tab-calidad").className = "color-normal";
        document.getElementById("tab-disenio").className = "color-normal";
        document.getElementById("tab-rendimiento").className = "color-normal";
        document.getElementById("tab-seguridad").className = "color-hover";
        document.getElementById("tab-conveniencia").className = "color-normal";
        document.getElementById("calidad").className = "d-none";
        document.getElementById("disenio").className = "d-none";
        document.getElementById("rendimiento").className = "d-none";
        document.getElementById("seguridad").className = "d-block";
        document.getElementById("conveniencia").className = "d-none";
        document.getElementById("img-carrusel").src = Slider4;
        break;
      case "conveniencia":
        document.getElementById("tab-calidad").className = "color-normal";
        document.getElementById("tab-disenio").className = "color-normal";
        document.getElementById("tab-rendimiento").className = "color-normal";
        document.getElementById("tab-seguridad").className = "color-normal";
        document.getElementById("tab-conveniencia").className = "color-hover";
        document.getElementById("calidad").className = "d-none";
        document.getElementById("disenio").className = "d-none";
        document.getElementById("rendimiento").className = "d-none";
        document.getElementById("seguridad").className = "d-none";
        document.getElementById("conveniencia").className = "d-block";
        document.getElementById("img-carrusel").src = Slider5;
        break;
      default:
        break;
    }
  };

  return (
    <Fragment>
      <link rel="preload" as="image" href={Slider1} />
      <link rel="preload" as="image" href={Calidad1} />
      <link rel="preload" as="image" href={Calidad} />
      <link rel="preload" as="image" href={Calidad2} />
      <link rel="preload" as="image" href={Galeria1} />
      <link rel="preload" as="image" href={Galeria2} />
      <link rel="preload" as="image" href={Galeria3} />
      <link rel="preload" as="image" href={Galeria4} />
      <link rel="preload" as="image" href={Galeria5} />
      <link rel="preload" as="image" href={Galeria6} />
      <Container fluid={true}>
        <Row>
          <Col md={12} className="px-0">
            <div>
              <Image
                src={Slider1}
                alt="Grandi10 Banner"
                className="banner"
                id="img-carrusel"
                fluid
              />
            </div>
          </Col>
        </Row>
      </Container>
      <div className="menu-vehiculo sticky-top">
        <Container>
          <Row className="py-2 py-md-4">
            <Col xs={2} md={2} className="my-auto d-none d-sm-block">
              <h1 className="menu-modelo">GRAND i10 HB</h1>
            </Col>
            <Col
              xs={12}
              md={7}
              className="my-auto vehiculo-item text-md-center"
            >
              <ul className="my-auto p-0 m-0">
                <li
                  id="tab-calidad"
                  onClick={() => onChangeMenu("calidad")}
                  className="color-hover"
                >
                  Calidad de tiempo
                </li>
                <li
                  id="tab-disenio"
                  onClick={() => onChangeMenu("disenio")}
                  className="color-normal"
                >
                  Diseño
                </li>
                <li
                  id="tab-rendimiento"
                  onClick={() => onChangeMenu("rendimiento")}
                  className="color-normal"
                >
                  Rendimiento
                </li>
                <li
                  id="tab-seguridad"
                  onClick={() => onChangeMenu("seguridad")}
                  className="color-normal"
                >
                  Seguridad
                </li>
                <li
                  id="tab-conveniencia"
                  onClick={() => onChangeMenu("conveniencia")}
                  className="color-normal"
                >
                  Conveniencia
                </li>
              </ul>
            </Col>
            <Col xs={3} md={1} className="text-center my-auto cont-extra">
              <a
                href="static/media/grandi10hb23-ficha-tecnica.8541807e.pdf"
                className="text-reset text-decoration-none"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faDownload} />
                <span className="menu-extra"> Ficha</span>
              </a>
            </Col>
            <Col
              xs={3}
              md={1}
              className="text-center my-auto cont-extra pr-md-0"
            >
              <Link
                to="/cotizador/grandi10hb"
                className="text-reset text-decoration-none"
              >
                <FontAwesomeIcon icon={faCar} />
                <span className="menu-extra"> Cotizar</span>
              </Link>
            </Col>
            <Col
              xs={3}
              md={1}
              className="text-center my-auto cont-extra pr-md-0"
            >
              <Link
                to="/test-drive/grandi10hb"
                className="text-reset text-decoration-none"
              >
                <FontAwesomeIcon icon={faCar} />
                <span className="menu-extra"> Test Drive</span>
              </Link>
            </Col>
          </Row>
        </Container>
      </div>
      {/***************************************** calidad ***************************************/}
      <section id="calidad">
        <Container className="py-4 py-md-5">
          <Row>
            <Col md={12} className="text-center">
              <h2 className="model-title">Grand i10 HB</h2>
              <h3 className="model-title">Mueve tus emociones</h3>
              <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                El Grand i10 ya está aquí y está creando oleadas de emoción con su atrevido estilo urbano.
                Hyundai ha reinventado por completo el automóvil familiar, su estilizada apariencia destaca entre la multitud
                y está perfectamente a la altura para viajes largos en la familia y amigos.
              </p>
            </Col>
          </Row>
          <Row>
            <Col md={12} className="bg-black py-2 px-2 py-md-4 px-md-0">
              <video
                loop
                controls
                style={
                  {
                    position: "relative",
                    width: "100%",
                    objectFit: "cover",
                  }
                }
              >
                <source
                  src={Interior1}
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </Col>
          </Row>
        </Container>
        <div className="bg-landing">
          <Container>
            <Row className="py-3 py-md-5">
              <Col md={6} className="my-auto order-2 order-md-1">
                <h3 className="specs-subtitle mt-4 pt-2 px-3 px-md-0">
                  Sé el primero en evolucionar
                </h3>
                <p className="specs-text px-3 px-md-0">
                  Con un diseño exuberante y tecnológico, brinda una facilidad inteligente para tu vida. Te ofrece mucho espacio para tú comodidad. Solo piensa en tu Grand i10 HB como un espacio cómodo al momento de manejar, que te sorprenderá con sus características de conveniencia, gran espacio y moderno diseño interior.
                </p>
              </Col>
              <Col md={6} className="my-auto order-1 order-md-2">
                <Image src={Calidad1} alt="Accent Calidad1" className="img-fluid2" fluid />
              </Col>
            </Row>
            <Row className="py-3 py-md-5">
              <Col md={6} className="my-auto">
                <Image src={Calidad2} alt="Accent Calidad2" className="img-fluid2" fluid />
              </Col>
              <Col md={6} className="my-auto">
                <h3 className="specs-subtitle mt-4 pt-2 px-3 px-md-0">
                  Hecho para esos momentos perfectos
                </h3>
                <p className="specs-text px-3 px-md-0">
                  Hay mucho por hacer y el Grand i10 te ayuda a hacerlo con estilo. Es joven, deportivo y te enamorarás de él a primera vista. Trae un diseño moderno, un interior espacioso y versátil con opciones de conectividad, características de seguridad.
                </p>
              </Col>
            </Row>
          </Container>
        </div>
        <Container>
          <Row className="py-3 py-md-5">
            <Col md={12} className="text-center">
              <h2 className="galeria-titulo my-3 pb-2 pb-md-4">Galería</h2>
              <div>
                <Swiper {...gallerySwiperParams}>
                  <div>
                    <Image
                      src={Galeria1}
                      alt="Grand i10 HB Slider 1"
                      className="galeria1"
                    />
                  </div>
                  <div>
                    <Image
                      src={Galeria2}
                      alt="Grand i10 HB Slider 2"
                      className="galeria1"
                    />
                  </div>
                  <div>
                    <Image
                      src={Galeria3}
                      alt="Grand i10 HB Slider 3"
                      className="galeria1"
                    />
                  </div>
                  <div>
                    <Image
                      src={Galeria4}
                      alt="Grand i10 HB Slider 4"
                      className="galeria1"
                    />
                  </div>
                  <div>
                    <Image
                      src={Galeria5}
                      alt="Grand i10 HB Slider 5"
                      className="galeria1"
                    />
                  </div>
                  <div>
                    <Image
                      src={Galeria6}
                      alt="Grand i10 HB Slider 6"
                      className="galeria1"
                    />
                  </div>
                </Swiper>
                <Swiper {...thumbnailSwiperParams}>
                  <div>
                    <Image
                      src={Galeria1}
                      alt="Grand i10 HB Slider 1"
                      className="galeria2"
                    />
                  </div>
                  <div>
                    <Image
                      src={Galeria2}
                      alt="Grand i10 HB Slider 2"
                      className="galeria2"
                    />
                  </div>
                  <div>
                    <Image
                      src={Galeria3}
                      alt="Grand i10 HB Slider 3"
                      className="galeria2"
                    />
                  </div>
                  <div>
                    <Image
                      src={Galeria4}
                      alt="Grand i10 HB Slider 4"
                      className="galeria2"
                    />
                  </div>
                  <div>
                    <Image
                      src={Galeria5}
                      alt="Grand i10 HB Slider 5"
                      className="galeria2"
                    />
                  </div>
                  <div>
                    <Image
                      src={Galeria6}
                      alt="Grand i10 HB Slider 6"
                      className="galeria2"
                    />
                  </div>
                </Swiper>
              </div>
            </Col>
          </Row>
        </Container>
        <div className="bg-landing">
          <Container>
            <Row className="py-3 py-md-5">
              <Col xs={6} md={6}></Col>
              <Col xs={6} md={6} className="text-right">
                <span
                  onClick={() => onChangeMenu("disenio")}
                  className="titulo-navegacion"
                >
                  Diseño
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    className="ml-2 ml-md-3"
                  />
                </span>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      {/***************************************** disenio ***************************************/}
      <section id="disenio" className="d-none">
        <Container className="py-4 py-md-5">
          <Row>
            <Col md={12} className="text-center">
              <h2 className="model-title">Diseño exterior</h2>
              <h3 className="model-title">Joven y Atrevido</h3>
              <p className="model-text mt-3 px-3 px-md-0">
                El Grand i10 HB es atrevido en diseño, conectividad equipamiento y espacio. ¿Te atrevés a conocer más?
              </p>
              <p className="model-text mt-3 px-3 px-md-0">
                Su diseño exterior, trae un estilo joven, deportivo y estilizado. Desde la gran apertura de refrigeración hasta las líneas de carácter masculino que recorren el capó, cada detalle refleja atletismo decidido. Los faros inclinados hacia atrás y las lentes de proyección transmiten una sensación de alta tecnología a la vez que la parrilla estilo cascada, agregan un toque premium.
              </p>
            </Col>
          </Row>
        </Container>
        <Container style={{ minHeight: '300px' }} className="cotizador pb-5">
          <a href="https://my.matterport.com/show/?m=4GZduYTM3qG" target="_blank" rel="noopener noreferrer">
            <center>
              <Image src={ShowRoom} alt="Showroom Virtual Grand i10" fluid width={700} height={350} />
            </center>
          </a>
        </Container>
        <div className="bg-landing">
          <Container>
            <Row className="py-3 py-md-5">
              <Col md={12} className="text-center">
                <h2 className="specs-subtitle mt-4 pb-3 px-3 px-md-0">
                  Diseño Interior
                </h2>
                <h3 className="specs-subtitle mt-4 pb-3 px-3 px-md-0">
                  Comodidad en cada rincón
                </h3>
                <p className="specs-text mt-2 pb-md-4 px-3 px-md-0">
                  Te vas a sorprender de todo lo que ofrece el Grand i10 HB, no solo por su renovado y elegante diseño,
                  sino por el confort que hace que todos los pasajeros viajen cómodos.
                </p>
              </Col>
            </Row>
            <Row className="pb-3 pb-md-2 mt-4">
              <Col md={4} className="mt-3 mt-md-4">
                <Image src={Interior2} alt="Tablero Kona electrico" fluid className="animacion-imagen" />
                <h3 className="specs-text mt-3 px-3 px-md-0 text-center">
                  <b>
                    Computador a bordo
                  </b>
                </h3>
              </Col>
              <Col md={4} className="mt-3 mt-md-4">
                <Image src={Interior3} alt="Transmision Kona electrico" fluid
                  className="animacion-imagen" />
                <h3 className="specs-text mt-3 px-3 px-md-0 text-center">
                  <b> Pantalla táctil Apple Car Play / Android Auto
                  </b>
                </h3>
              </Col>
              <Col md={4} className="mt-3 mt-md-4">
                <Image src={Interior4} alt="Radio Kona electrico" fluid className="animacion-imagen" />
                <h3 className="specs-text mt-3 px-3 px-md-0 text-center">
                  <b>Bluetooth con reconocimiento de voz y control de audio al volante </b>
                </h3>
              </Col>
            </Row>
            <Row className="pb-3 pb-md-2 mt-4">
              <Col md={4} className="mt-3 mt-md-4">
                <Image src={Interior5} alt="Tablero Kona electrico" fluid className="animacion-imagen" />
                <h3 className="specs-text mt-3 px-3 px-md-0 text-center">
                  <b>
                    Aire acondicionado manual
                  </b>
                </h3>
              </Col>
              <Col md={4} className="mt-3 mt-md-4">
                <Image src={Interior6} alt="Transmision Kona electrico" fluid
                  className="animacion-imagen" />
                <h3 className="specs-text mt-3 px-3 px-md-0 text-center">
                  <b> Panel de forma paramétrica y rejillas de
                    ventilación en forma de hélice deportivo
                  </b>
                </h3>
              </Col>
              <Col md={4} className="mt-3 mt-md-4">
                <Image src={Interior7} alt="Radio Kona electrico" fluid className="animacion-imagen" />
                <h3 className="specs-text mt-3 px-3 px-md-0 text-center">
                  <b>Amplio espacio de maletero 260 Lt</b>
                </h3>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={12}>
                <Image src={Interior8} alt="Accent Banner" fluid />
              </Col>
            </Row>
            <Row className="py-3 py-md-5">
              <Col xs={6} md={6} className="text-left">
                <span
                  onClick={() => onChangeMenu("calidad")}
                  className="titulo-navegacion"
                >
                  <FontAwesomeIcon
                    icon={faChevronLeft}
                    className="mr-2 mr-md-3"
                  />
                  Calidad de tiempo
                </span>
              </Col>
              <Col xs={6} md={6} className="text-right">
                <span
                  onClick={() => onChangeMenu("rendimiento")}
                  className="titulo-navegacion"
                >
                  Rendimiento
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    className="ml-2 ml-md-3"
                  />
                </span>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      {/***************************************** rendimiento ***************************************/}
      <section id="rendimiento" className="d-none">
        <Container className="py-4 py-md-5">
          <Row>
            <Col md={12} className="text-center">
              <h2 className="model-title">Potencia y desempeño</h2>
              <h3 className="model-title">Compacto con gran rendimiento</h3>
              <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                El Grand i10 HB cuenta con su nuevo motor Kappa de 1.2 litros el cual es económico y confiable,
                aparte de comprometer su potencia. Este moderno motor ha sido mejorado para aumentar el rendimiento a
                velocidades medias y fue optimizado para reducir su nivel de ruido y vibraciones.
              </p>
            </Col>
          </Row>
          <Row className="py-3 py-md-5">
            <Col md={6} className="mt-4">
              <Image src={Rendimiento1} alt="Accent Motor" fluid />
              <p className="specs-text px-3 px-md-0">
                Motor  Tipo Kappa 1.2 MPI DUAL CVVT
                Potencia máxima (hp@rpm) 87 / 6000
                Torque máximo  (Nm@rpm) 120 / 4000
                Sistema de distribución Cadena
              </p>
            </Col>
            <Col md={6} className="mt-4">
              <Image src={Rendimiento2} alt="Accent Transmision" fluid />
              <p className="specs-text px-3 px-md-0">
                Transmisión Manual 5 velocidades + reversa
              </p>
            </Col>
          </Row>
        </Container>
        <Container>
          <Row className="py-3 py-md-5">
            <Col md={12}>
              <Image src={Rendimiento3} alt="Accent Banner" fluid />
            </Col>
          </Row>
        </Container>
        <div className="bg-landing">
          <Container>
            <Row className="py-3 py-md-5">
              <Col xs={6} md={6} className="text-left">
                <span
                  onClick={() => onChangeMenu("disenio")}
                  className="titulo-navegacion"
                >
                  <FontAwesomeIcon
                    icon={faChevronLeft}
                    className="mr-2 mr-md-3"
                  />
                  Diseño
                </span>
              </Col>
              <Col xs={6} md={6} className="text-right">
                <span
                  onClick={() => onChangeMenu("seguridad")}
                  className="titulo-navegacion"
                >
                  Seguridad
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    className="ml-2 ml-md-3"
                  />
                </span>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      {/***************************************** seguridad ***************************************/}
      <section id="seguridad" className="d-none">
        <Container className="py-4 py-md-5">
          <Row>
            <Col md={12} className="text-center">
              <h2 className="model-title px-3 px-md-0">
                Seguridad y confort en movimiento
              </h2>
              <h3 className="model-title px-3 px-md-0">
                Protección en la que se puede confiar
              </h3>
              <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                Los dispositivos de seguridad, como los airbags dobles, sistema antibloqueo de frenado (ABS),
                control electrónico de estabilidad (ESC) y asistente de arranque en pendiente (HAC) proporcionan una
                gran seguridad para los ocupantes, esta construido con acero de alta resistencia y garantiza una seguridad
                completa para todos los pasajeros.
              </p>
            </Col>
          </Row>
          <Row className="py-3 py-md-5">
            <Col md={6}>
              <Image src={Seguridad1} alt="Accent Carroceria" fluid />
              <h3 className="specs-subtitle mt-4 pt-2 px-3 px-md-0">
                6 Airbags (conductor y pasajero + tórax y pelvis + cortina)
              </h3>
            </Col>
            <Col md={6}>
              <Image src={Seguridad2} alt="Accent Cinturones" fluid />
              <h3 className="specs-subtitle mt-4 pt-2 px-3 px-md-0">
                Sensor de parqueo posterior
              </h3>
            </Col>
          </Row>
          <Row className="py-3 py-md-5">
            <Col md={6}>
              <Image src={Seguridad3} alt="Accent Carroceria" fluid />
              <h3 className="specs-subtitle mt-4 pt-2 px-3 px-md-0">
                Sistema de anclaje para silla de niños ISOFIX
              </h3>
            </Col>
            <Col md={6}>
              <Image src={Seguridad4} alt="Accent Cinturones" fluid />
              <h3 className="specs-subtitle mt-4 pt-2 px-3 px-md-0">
                Asistente de arranque en pendiente (HAC)
              </h3>
            </Col>
          </Row>
          <Row className="py-3 py-md-5">
            <Col md={6}>
              <Image src={Seguridad5} alt="Accent Carroceria" fluid />
              <h3 className="specs-subtitle mt-4 pt-2 px-3 px-md-0">
                Cámara de reversa
              </h3>
            </Col>
            <Col md={6}>
              <Image src={Seguridad6} alt="Accent Cinturones" fluid />
              <h3 className="specs-subtitle mt-4 pt-2 px-3 px-md-0">
                Seguros eléctricos con bloqueo central
              </h3>
            </Col>
          </Row>
        </Container>
        <div className="bg-landing">
          <Container>
            <Row className="py-3 py-md-5">
              <Col xs={6} md={6} className="text-left">
                <span
                  onClick={() => onChangeMenu("rendimiento")}
                  className="titulo-navegacion"
                >
                  <FontAwesomeIcon
                    icon={faChevronLeft}
                    className="mr-2 mr-md-3"
                  />
                  Rendimiento
                </span>
              </Col>
              <Col xs={6} md={6} className="text-right">
                <span
                  onClick={() => onChangeMenu("conveniencia")}
                  className="titulo-navegacion"
                >
                  Conveniencia
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    className="ml-2 ml-md-3"
                  />
                </span>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      {/***************************************** conveniencia ***************************************/}
      <section id="conveniencia" className="d-none">
        <Container className="pt-4 pt-md-5">
          <Row>
            <Col md={12} className="text-center">
              <h2 className="model-title">Toma el control del camino</h2>
              <p className="model-text mb-md-4 mt-3 px-3 px-md-0">
                Disfruta de la comodidad, control y elegancia con características tecnológicas centradas en que el
                conductor disfrute una experiencia de manejo única. Sus componentes tecnológicos de última generación
                te mantienen conectado y te dan más claridad al recorrer el camino.
              </p>
            </Col>
          </Row>
          <Row className="py-3 py-md-5">
            <Col md={3} >
              <Image src={Conveniencia1} alt="Accent Volante" fluid />
              <h3 className="model-text mb-md-5 mt-3 px-3 px-md-0">
                Luces posteriores (LED)
              </h3>
            </Col>
            <Col md={3}>
              <Image src={Conveniencia2} alt="Accent Volante" fluid />
              <h3 className="model-text mb-md-5 mt-3 px-3 px-md-0">
                Asiento posterior plegable 6:4
              </h3>
            </Col>
            <Col md={3}>
              <Image src={Conveniencia3} alt="Accent Audio" fluid />
              <h3 className="model-text mb-md-5 mt-3 px-3 px-md-0">
                Luz en el maletero
              </h3>
            </Col>
            <Col md={3}>
              <Image src={Conveniencia4} alt="Accent Volante" fluid />
              <h3 className="model-text mb-md-5 mt-3 px-3 px-md-0">
                Asiento del conductor regulable en altura
              </h3>
            </Col>
          </Row>
          <Row className="py-3 py-md-5">
            <Col md={4} className="mt-4">
              <Image src={Conveniencia5} alt="Accent Volante" fluid />
              <p className="specs-text px-3 px-md-0">
                Volante regulable en altura
              </p>
            </Col>
            <Col md={4} className="mt-4">
              <Image src={Conveniencia6} alt="Accent Audio" fluid />
              <p className="specs-text px-3 px-md-0">
                Tercera luz stop (LED)
              </p>
            </Col>
            <Col md={4} className="mt-4">
              <Image src={Conveniencia7} alt="Accent Audio" fluid />
              <p className="specs-text px-3 px-md-0">
                Luces automáticas
              </p>
            </Col>
          </Row>
        </Container>
        <div className="bg-landing">
          <Container>
            <Row className="pt-3 pt-md-5">
              <Col md={12} className="text-center">
                <Image src={Conveniencia8} alt="Staria Interior" fluid />
              </Col>
            </Row>
            <Row className="py-3 py-md-5">
              <Col xs={6} md={6} className="text-left">
                <span
                  onClick={() => onChangeMenu("seguridad")}
                  className="titulo-navegacion"
                >
                  <FontAwesomeIcon
                    icon={faChevronLeft}
                    className="mr-2 mr-md-3"
                  />
                  Seguridad
                </span>
              </Col>
              <Col xs={6} md={6}></Col>
            </Row>
          </Container>
        </div>
      </section>
    </Fragment>
  );
}
export default InfoGrandi10Hb;